import { Html } from '@react-three/drei'
import { useState, useEffect } from 'react'

export default function MobileDevice(){
    return <Html
        transform
        wrapperClass="fullscreenHTML"
        distanceFactor={ 1.17 }
        rotation={[0, -3.14, 0]}
        >
        <div>Radio 3D is not available for small screen</div>
    </Html>
}
